// extracted by mini-css-extract-plugin
module.exports = {"container":"nocolorlayernotification_container__8z8rF","icon":"nocolorlayernotification_icon__2NIrK","button":"nocolorlayernotification_button__1M2TV"};